import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  Employment,
  EmploymentCreateRequest,
  EmploymentCreateResponse,
  EmploymentUpdateRequest,
  EmploymentUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class EmploymentRelationshipService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/employments/';
  }

  public getEmploymentRelationships(): Observable<Employment[]> {
    const url = this.endpoint;
    return this.httpClient.get<Employment[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<Employment> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<Employment>(url, request);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getEmploymentRelationshipById(id: number): Observable<Employment> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<Employment>(url);
  }

  public deleteEmploymentRelationship(id: number): Observable<Employment> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<Employment>(url);
  }

  public createEmploymentRelationship(requestBody: EmploymentCreateRequest): Observable<EmploymentCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<EmploymentCreateResponse>(url, requestBody);
  }

  public updateEmploymentRelationship(id: number, requestBody: EmploymentUpdateRequest): Observable<EmploymentUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<EmploymentUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
